export async function getSelectionPos() {
  //@ts-ignore
  const containerRef = window.containerRef;
  const canvasIframe = containerRef.current.contentWindow;
  const canvasCoords = await canvasIframe.GetSelectionPos();

  return canvasCoords;
}
